// Port of api/fuel/app/classes/filter/search/games/sorts/query/play/count.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'player.count',
	post: false,
	require: function(config, filter) { return sorted('player.count', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('p.play_players', '>', 0)
		query.order('p.play_players', sortReverse('player.count', filter), sortPriority('player.count', filter))
	}
}
